// 瀑布流 貼文 元件
import { useSelector } from 'react-redux';
import { userState } from '@/slices/userSlice';
import { urlState } from '@/slices/urlSlice';
import UserAvatar from '../user/UserAvatar'; // 頭像、頭像框
import { DEFAULT_IMG, DEFAULT_USER_IMG } from '@/common/constant';
import VoiceVoteLiked from '../event/voice-vote/VoiceVoteLiked';

const MasonryPostComponent = ({ post = {}, handleClick, onToggleLike, type }) => {
    const { user } = useSelector(userState);
    const { forumUrl } = useSelector(urlState);

    // 活動頁面
    const isAcgPage = type === 'acg';
    const THEME_MAP = {
        default: {
            containerClass: 'bg-white border-1 border-black',
            imageWrapperClass: 'bg-black1',
            titleClass: 'text-black text-h6',
        },
        acg: {
            containerClass: 'bg-black border-jblack border-1',
            imageWrapperClass: 'bg-black',
            titleClass: 'text-white text-h6',
        },
        classic: {
            containerClass: 'bg-white',
            imageWrapperClass: '',
            titleClass: 'text-[#D3392F] text-btn1',
        },
        life: {
            containerClass: 'bg-black',
            imageWrapperClass: '',
            titleClass: 'text-[#fff] text-btn1',
        },
        bl: {
            containerClass: 'bg-[#fff] border-[#E5E5E5] border-1',
            imageWrapperClass: '',
            titleClass: 'text-[#5B6FA6] text-btn1',
        },
    };

    const theme = THEME_MAP[type] || THEME_MAP.default;

    const {
        title,
        imageCover,
        author,
        authorImage,
        authorFrame,
        category,
        slug,
        likeAdd = 0,
        uid,
        isLiked = 0,
        id,
    } = post;

    const isAuthor = user?.uid === uid;

    // 貼文連結
    const link = `${forumUrl}/${category}/${slug}`;

    return (
        <div
            className={`block rounded-[10px] overflow-hidden group  ${theme.containerClass}`}
            onClick={handleClick}
        >
            {/* 圖片 */}
            <a
                href={link}
                target="_blank"
                rel="noreferrer noopener"
                className={`overflow-hidden min-h-[200px] flex items-center usm:min-h-[120px] relative
                    ${theme.imageWrapperClass}`}
                aria-label="前往貼文"
            >
                <img
                    className="gtm-post w-full max-h-[580px] object-cover object-top trans group-hover:scale-[1.1] min-h-[200px] usm:min-h-[120px] usm:!scale-[1]"
                    src={imageCover || DEFAULT_IMG}
                    alt="post"
                />
            </a>

            <div className="px-[16px] pt-[12px] text-left relative usm:px-[8px]">
                {/* 標題 */}
                <h3
                    className={` line-clamp-2 usm:text-btn1
                    ${theme.titleClass}`}
                >
                    {title}
                </h3>

                <div className="between-center gap-x-[12px] my-[16px] usm:mt-[10px] usm:mb-[6px]">
                    <a
                        href={forumUrl + '/user/' + uid}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="flex-grow flex flex-1 items-center gap-x-[12px] group/author relative z-[1] min-w-0 py-[6px] umd:gap-x-[7px]"
                    >
                        {/* 作者頭像 */}
                        <UserAvatar
                            style="w-[20px]"
                            avatar={isAuthor ? user?.image || DEFAULT_USER_IMG : authorImage}
                            avatarFrame={isAuthor ? user?.avatarFrame : authorFrame}
                        />

                        {/* 作者名稱 */}
                        <p className="flex-1 line-clamp-1 text-btn2 text-black6 trans group-hover/author:text-black9">
                            {isAuthor ? user?.nickname : author}
                        </p>
                    </a>

                    {/* 讚數 */}
                    <button
                        onClick={() => onToggleLike(id)}
                        className="flex items-center gap-x-[5px] py-[6px] flex-shrink-0 text-bd3n text-black4 relative z-[1]"
                    >
                        {/* 愛心 */}
                        <VoiceVoteLiked isLiked={isLiked} color="#5B6FA6" />
                        {likeAdd}
                    </button>
                </div>

                <a
                    href={link}
                    rel="noreferrer noopener"
                    className="absolute z-[0] w-full h-full top-0 left-0"
                    aria-label="前往貼文"
                />
            </div>
        </div>
    );
};

export default MasonryPostComponent;
